module.exports = __webpack_public_path__ + "static/media/Icon1.cafc1524.png";